<template lang="pug">
    .about-ourportfolio
        .about-ourportfolio-title
            p   {{ lenguageSelected.content }}
            .about-ourportfolio-images-content
                .about-ourportfolio-images
                    img(:src="peru", v-if="countrySelected == 'peru'")
                    img(:src="colombia" v-if="countrySelected == 'colombia'")
                    img(:src="chile" v-if="countrySelected == 'chile'")
                    img(:src="ecuador" v-if="countrySelected == 'ecuador'")
            
            .about-ourportfolio-images-buttons
                .md-section-4-btn(@click="changeCountry('chile')", :class="countrySelected == 'chile'? 'active' : ''")
                    | Chile
                .md-section-4-btn(@click="changeCountry('colombia')", :class="countrySelected == 'colombia'? 'active' : ''")
                    | Colombia
                .md-section-4-btn(@click="changeCountry('peru')", :class="countrySelected == 'peru'? 'active' : ''")
                    | Peru
                .md-section-4-btn(@click="changeCountry('ecuador')", :class="countrySelected == 'ecuador'? 'active' : ''")
                    | Ecuador
</template>

<script>
import peru from '@img/about/peru.jpg'
import chile from '@img/about/chile.jpg'
import colombia from '@img/about/colombia.jpg'
import ecuador from '@img/about/ecuador.png'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            lenguage: 'EN',
            lenguageEN: {
                content: 'ATP’s Comprehensive Digital Infrastructure Platform',
            },
            lenguageES: {
                content: 'Nuestra Plataforma de Infraestructura Digital Integral',
            },
            peru: peru,
            chile: chile,
            colombia: colombia,
            ecuador: ecuador,
            countrySelected: 'peru'
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
    methods:{
        changeCountry: function(country){
            this.$data.countrySelected = country
        }
    }
}
</script>

<style lang="scss" scoped>
    .about-ourportfolio-images-content{
        text-align: center;
        .about-ourportfolio-images{
            display: inline-block;
            max-width: 500px;
            margin-top: 40px;
            margin-bottom: 40px;
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/molecules/PmOurPortfolio.vue